import { render, staticRenderFns } from "./GastroInserzioneVideocapuslaEdit.vue?vue&type=template&id=52e3b9fd"
import script from "./GastroInserzioneVideocapuslaEdit.vue?vue&type=script&lang=js"
export * from "./GastroInserzioneVideocapuslaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports